import { render, staticRenderFns } from "./profile-credentials.vue?vue&type=template&id=5e9d0b5c&scoped=true&"
import script from "./profile-credentials.vue?vue&type=script&lang=js&"
export * from "./profile-credentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d0b5c",
  null
  
)

export default component.exports